import { render } from "./AppFavourite.vue?vue&type=template&id=67b21726"
import script from "./AppFavourite.vue?vue&type=script&lang=js"
export * from "./AppFavourite.vue?vue&type=script&lang=js"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__